import React, { useState, useEffect } from 'react';

// import {} from "react-spinn"
import { useApolloClient } from '@apollo/react-hooks';
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import { Controller, useForm } from 'react-hook-form';
import { InterfaceFormValues, useAuth } from 'services/auth';
import { usePassword } from 'services/redefine-password';

import ArrowRight from 'assets/Arrow.png';
import CheckFillIcon from 'assets/check-fill.svg';
import CheckOutlineIcon from 'assets/check-outline.svg';
import EyesClosedIcon from 'assets/eyes-closed.svg';
import EyesOpenIcon from 'assets/eyes-open.svg';
import QuickColored from 'assets/QuickColored.svg';
import { CustomButton } from 'components/CustomButton';
import { InputCN } from 'components/InputCN';

type LoginFormProps = {
  isScreenLarge: boolean;
};

const useStyles = makeStyles({
  myButton: {
    '&:disabled': {
      backgroundColor: '#024E7C',
    },
  },
});

/* eslint-disable */
export function LoginForm({ isScreenLarge }: LoginFormProps) {
  const client = useApolloClient();
  const classes = useStyles();

  const [formType, setFormType] = useState<'sign' | 'forgot-password'>('sign');
  const [security, setSecurity] = useState<boolean>(true);
  const [hover, setHover] = useState<boolean>(false);
  const [shouldRemember, setShouldRemember] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const {
    login,
    loading,
    defaultValues,
    onSaveLocalStorage,
  } = useAuth(client, shouldRemember);

  const { onSubmit: sendPasswordRequest, loading: loadingPasswordReset } = usePassword();

  const { control, setValue, handleSubmit } = useForm({ defaultValues });

  async function onSubmit({ username, password }: InterfaceFormValues) {
    if (formType === "sign") {
      login({
        variables: {
          username,
          password,
        },
      })
        .then(() => {
          if (shouldRemember) {
            onSaveLocalStorage({ username, password })
          }
        })
        .catch(() => {
          enqueueSnackbar('Login inválido!', { variant: 'error' });
        });

      return;
    }

    try {
      await sendPasswordRequest(username);

      enqueueSnackbar('Enviado ao email!', { variant: 'success' });
      setTimeout(() => {
        setFormType("sign");
      }, 2200);
    } catch (error) {
      enqueueSnackbar('Erro na solicitação!', { variant: 'error' });
    }

  }

  useEffect(() => {
    if (defaultValues.username && defaultValues.password) {
      setValue("username", defaultValues.username);
      setValue("password", defaultValues.password);

      setShouldRemember(true);
    }
  }, [defaultValues]);

  useEffect(() => {
    setValue("username", "");
  }, [formType]);
  return (
    <Grid
      container
      direction="column"
      style={{
        width: isScreenLarge ? "40%" : "100%",
        height: "100%",
        paddingLeft: isScreenLarge ? "80px" : 30,
        paddingRight: isScreenLarge ? "80px" : 30,
        gap: isScreenLarge ? 80 : 30,
        paddingTop: isScreenLarge ? 100 : 60
      }}
    >
      {
        !isScreenLarge && (
          <Box style={{ width: 70, height: 70, alignSelf: "center" }}>
            <img
              src={QuickColored}
              style={{
                width: "100%",
                height: "100%"
              }}
            />
          </Box>
        )
      }
      <Typography
        style={{
          fontFamily: "Roboto, sans-serif",
          fontSize: isScreenLarge ? 24 : 18,
          lineHeight: isScreenLarge ? "26px" : "auto",
          fontWeight: 400,
          color: "#0370B2",
          textAlign: "center"
        }}
      >
        Acompanhe as mudanças da {isScreenLarge && <br />}
        sua empresa pelo Quick ERP.
      </Typography>

      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 30
        }}
      >
        <Typography
          style={{
            fontSize: isScreenLarge ? 32 : 24,
            lineHeight: isScreenLarge ? "36px" : "auto",
            fontWeight: 600,
            color: "black",
            textAlign: isScreenLarge ? "left" : "center"
          }}
        >
          {formType === "sign" ? "Login" : "Recuperar Senha"}
        </Typography>

        <Controller
          as={
            <InputCN
              placeholder="Email"
              autoFocus
              focused={false}
            />
          }
          {...{ control, name: 'username' }}
        />
        {
          formType === "sign" && (
            <Controller
              as={
                <InputCN
                  placeholder="Senha"
                  type={security ? "password" : "text"}
                  endAdornment={
                    <Box
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        // paddingRight: 10,
                        right: 10,
                        display: "flex",
                        alignItems: "center"
                      }}
                      onClick={() => setSecurity(!security)}
                    >
                      <img
                        src={security ? EyesOpenIcon : EyesClosedIcon}
                        alt="Password"
                        style={{
                          width: 25,
                          height: 25,
                        }}
                      />
                    </Box>
                  }
                />
              }
              {...{ control, name: 'password' }}
              style={{
                paddingRight: 30
              }}
            />
          )
        }

        {
          formType === "sign" && (
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center"
              }}
            >
              <Box
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer"
                }}
                onClick={() => setShouldRemember(!shouldRemember)}
              >
                <img
                  src={shouldRemember ? CheckFillIcon : CheckOutlineIcon}
                  alt="Password"
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                />
              </Box>
              <Typography
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontSize: 16,
                  fontWeight: 300,
                  color: "#131313"
                }}
              >
                Lembrar senha
              </Typography>
            </Box>
          )
        }

        {
          formType === "sign" && (
            <span
              className="forgot-password"
              onClick={() => setFormType("forgot-password")}
              style={{
                marginTop: -20
              }}
            >
              Esqueceu a senha?
            </span>
          )
        }

        {formType === "sign" &&
          <CustomButton
            className={classes.myButton}
            width="170px"
            icon={
              hover || !isScreenLarge ?
                <>
                  {"LOGIN"}
                </>
                : (
                  <>
                    <img
                      src={ArrowRight}
                      style={{
                        display: loading ? "none" : "block",
                        width: "150px",
                        height: "25px",
                        transform: "rotate(180deg)"
                      }}
                    />
                  </>
                )
            }
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            type="submit"
            disabled={!!loading}
            loading={!!loading}
            customDisable={!!loading}
            style={{
              alignSelf: "end",
              fontSize: 16
            }}
          />
        }

        {formType === "forgot-password" && (
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            style={{
              width: "100%"
            }}
          >
            <span
              className="forgot-back"
              onClick={() => setFormType("sign")}
            >
              Voltar
            </span>

            <CustomButton
              className={classes.myButton}
              width="170px"
              icon={
                hover || !isScreenLarge ?
                  <>ENVIAR</>
                  : (
                    <img
                      src={ArrowRight}
                      style={{
                        display: loadingPasswordReset ? "none" : "block",
                        width: "150px",
                        height: "25px",
                        transform: "rotate(180deg)"
                      }}
                    />
                  )
              }
              onMouseOver={() => setHover(true)}
              onMouseOut={() => setHover(false)}
              disabled={loadingPasswordReset}
              customDisable={loadingPasswordReset}
              type="submit"
              style={{
                alignSelf: "end",
                fontSize: 16
              }}
            />
          </Grid>
        )}
      </form>
    </Grid>
  );
}